import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatSnackBar } from '@angular/material';
import { AuthNoticeService } from '../../../core/auth';
import { ConfigDebtService} from '../../../core/e-commerce';
import { HttpClient } from '@angular/common/http';

@Component({
    selector: 'kt-dialog-product',
    templateUrl: './dialog-config-debt.component.html',
    styleUrls: ['./dialog-config-debt.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogConfigDebtComponent implements OnInit {

    detailForm: FormGroup;
    error: boolean = false;
    isLoadingResults = false;

    constructor(
        private configDebtService: ConfigDebtService,
        private _snackBar: MatSnackBar,
        private http: HttpClient,
        private dialog: MatDialog,
        private cdr: ChangeDetectorRef,
        public dialogRef: MatDialogRef<DialogConfigDebtComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: any,
        private fb: FormBuilder,
        private authNoticeService: AuthNoticeService,
    ) {
    }

    ngOnInit() {
        this.authNoticeService.setNotice(null);
        this.initForms();
    }

    initForms() {
        let model;
        if (this.data) {
            model = this.data;
        } else {
            model = {};
        }

        this.detailForm = this.fb.group({
            // id: [model.id, Validators.required],
            effectiveDate: [model.effectiveDate, Validators.required],
            debtAmountLimit: [model.debtAmountLimit, Validators.required],
            orderDueDays: [model.orderDueDays, Validators.required],
            firstDebtDays: [model.firstDebtDays, Validators.required],
            secondDebtDays: [model.secondDebtDays, Validators.required],
            firstDebtInterest: [model.firstDebtInterest, Validators.required],
            secondDebtInterest: [model.secondDebtInterest, Validators.required],
        });
    }

    saveOrderEvent() {
        const controls = this.detailForm.controls;
        if (this.detailForm.invalid) {
            Object.keys(controls).forEach(controlName => {
                    controls[controlName].markAsTouched();
                }
            );
            return;
        }

        if (this.data == null) {
            this.configDebtService.createDebtConfig(this.detailForm.value).subscribe(resp => {
                    this.dialogRef.close(true);
                    this.cdr.detectChanges();
                },
                error => {
                    let message = 'Ha ocurrido un error';
                    if (error.error === 'Duplicate entry') {
                        message = 'Ya existe una configuración para esta fecha';
                    }
                    this._snackBar.open(message, 'OK', {
                        duration: 3000,
                    });
                });
        } else {
            this.configDebtService.updateDebtConfig(this.detailForm.value, this.data.id).subscribe(() => {
                    this.dialogRef.close(true);
                },
                error => {
                    let message = 'Ha ocurrido un error';
                    this._snackBar.open(message, 'OK', {
                        duration: 3000,
                    });
                });
        }
    }

    onNoClick(): void {
        this.dialogRef.close(false);
    }

    isControlHasError(controlName: string, validationType: string): boolean {
        const control = this.detailForm.controls[controlName];
        if (!control) {
            return false;
        }

        return control.hasError(validationType) && (control.dirty || control.touched);
    }
}
